import { useState } from 'react';

import './PublishedBar.css';

/*
 * Confirmation of a publish, shown above the squad rather than in place
 * of it.
 *
 * Replacing the whole page with a share panel threw away the thing the
 * person had just spent five minutes building, at the exact moment they
 * most wanted to look at it. Everything that panel said fits in one strip:
 * it is published, here is the link, and the squad is still on screen and
 * still editable underneath.
 */
export default function PublishedBar({ slug, onDismiss }) {
	const [copied, setCopied] = useState(false);
	const shareUrl = `${window.location.origin}/draft/${slug}`;

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(shareUrl);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch {
			/* Refused over plain http and in some browsers; the field is
			 * selectable either way. */
			setCopied(false);
		}
	};

	return (
		<div className="published" role="status">
			<span className="published__label">Published</span>

			<input
				className="published__url"
				type="text"
				value={shareUrl}
				readOnly
				aria-label="Share link"
				onFocus={(event) => event.target.select()}
			/>

			<button type="button" className="button button--secondary published__copy" onClick={copy}>
				{copied ? 'Copied' : 'Copy link to share'}
			</button>

			<button
				type="button"
				className="published__dismiss"
				onClick={onDismiss}
				aria-label="Dismiss"
				title="Dismiss"
			>
				×
			</button>
		</div>
	);
}
